<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <v-icon large left>mdi-wrench-clock</v-icon>
                    <h6>Horas insumidas por Taller</h6>
                </v-card-title>
                <v-card-text class="pt-2">
                    <v-row dense>
                        <v-col cols="6" sm="6" md="3">
                            <v-select dense v-model="filtroidarea" :items="listadoareas" label="Filtro por Área"
                                item-text="nombre" item-value="codigo"></v-select>
                        </v-col>
                        <v-col cols="6" sm="6" md="3">
                            <v-text-field label="Filtro por N° OT" dense v-model="filtronumot">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row align="center" justify="space-around">
                        <v-btn tile color="success" @click="cargarListados()">
                            <v-icon left> mdi-magnify </v-icon>
                            Buscar
                        </v-btn>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-data-table dense :headers="headers" :items="listado" :loading="loadtable"
                no-data-text="No hay datos disponibles" loading-text="Cargando... Espere por favor"
                :single-expand="true" locale="es-ar" class="elevation-1" :items-per-page="1000" :footer-props="{
                itemsPerPageText: 'OTs por página',
            }">
            </v-data-table>

        </v-app>
    </div>
</template>

<script>
import axios from "../../axios-auth";

import jsPDF from "jspdf";
import "jspdf-autotable";
export default {
    data: (vm) => ({
        editedItem: {},
        editedIndex: -1,
        filtroidarea: "",
        filtronumot: "",
        listado: [],
        listadoareas: [{ nombre: 'Cableado', codigo: '1' },
        { nombre: 'Armado', codigo: '2' },
        { nombre: 'Tornería', codigo: '3' },
        { nombre: 'Carpintería Metálica', codigo: '4' },
        { nombre: 'Indirectos', codigo: '5' },
        { nombre: 'Todas', codigo: '' },
        ],
        loadtable: false,
        headers: [
            {
                text: "OT",
                align: "start",
                sortable: false,
                value: "otrabajo",
            },
            { text: "Área", value: "area", sortable: false },
            { text: "Horas Insumidas", value: "horasinsumidas", sortable: false },
            { text: "Horas Presupuestadas", value: "horaspres", sortable: false },
        ],
    }),

    computed: {
        show: {
            get() {
                // this.cargarListados();
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    methods: {
        cargarListados() {
            this.vaciarModels();
            this.loadtable = true;

            const numot = this.filtronumot;
            const idarea = this.filtroidarea;

            let self = this;

            axios
                .get("/Producto/ListadoHorasInsumidas?", {
                    params: {
                        filtronumot: numot,
                        filtroidarea: idarea,
                    },
                })
                .then((response) => {
                    self.listado = response.data;
                    self.loadtable = false;
                    //self.listadoP = response.data;
                })
                .catch((error) => {
                    self.listado = [];
                    console.log(error);
                });
        },
        vaciarModels() {
            this.listado = [];
        },
    },
};
</script>